export default __webpack_public_path__ + "static/media/HealthEMLoopAnim.2fc4c0c3.gif";